import styled, { keyframes, useTheme } from 'styled-components';
import { BodyMedium, Heading1Text, ParagraphMediumText } from '../Texts';
import Button from '../Button';
import { useState } from 'react';
import Line from '../Line';
import { PHONE_MEDIA_QUERY } from '../../common/responsive';

const InnerContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Container = styled.div`
  min-height: 600px;
  display: flex;
  justify-content: center;
  align-items: center;
  @media ${PHONE_MEDIA_QUERY} {
    gap: 30px;
    flex-direction: column;
    padding-top: 64px;
    padding-bottom: 64px;
  }
`;

const expandHeight = keyframes`
  0% {
    max-height: 0px;
  }
  100% {
    max-height: 50px;
  }
`;

const Answer = styled(BodyMedium)`
  overflow: hidden;
  animation: ${expandHeight} 0.5s ease-out forwards;
`;

const QuestionAnswer = ({ question, answer }) => {
  const [open, setOpened] = useState(false);

  return (
    <>
      <Line />
      <div
        onClick={() => setOpened(!open)}
        style={{
          padding: '20px 0px',
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          cursor: 'pointer',
        }}
      >
        <ParagraphMediumText>
          <b>{question}</b>
        </ParagraphMediumText>
        <img src='chevron-down.svg' />
      </div>
      {open && <Answer>{answer}</Answer>}
    </>
  );
};

const DEFAULT_QUESTIONS = [
  {
    question: 'What is a non-custodial wallet and why does it matter?',
    answer:
      'A non-custodial wallet means you, and only you, control your funds and private keys. You havefull ownership without the complexity — no one, including us, can move your assets.',
  },
  {
    question: 'Do I need to understand Web3 or wallets to use this?',
    answer:
      "Not at all. We've abstracted all the technical details so anyone can buy, sell, and hold tokens without knowing how wallets, seed phrases, or blockchains work.",
  },
  {
    question: "Can I sell tokens that aren't listed on exchanges?",
    answer:
      "Yes! Our platform lets you buy, sell, and even gift tokens that aren't listed on centralized exchanges.",
  },
  {
    question: 'How do I know my funds are safe?',
    answer:
      'We never have custody of your assets. Everything is secured through non-custodial wallets and industry best practices, giving you full control and transparency.',
  },
];

const Answers = ({ questions = DEFAULT_QUESTIONS }) => {
  const currentTheme = useTheme();

  return (
    <Container>
      <InnerContainer style={{ gap: 20, alignItems: 'flex-start' }}>
        <div>
          <Heading1Text
            style={{ color: currentTheme.text.title, width: '100%' }}
          >
            We've got
          </Heading1Text>
          <Heading1Text
            style={{ color: currentTheme.primary.primary, width: '100%' }}
          >
            answers
          </Heading1Text>
          <Button
            as='a'
            href='https://calendly.com/kevin-deks/deks-platform-intro'
            target='_blank'
            rel='noopener noreferrer'
          >
            SUPPORT
          </Button>
        </div>
      </InnerContainer>
      <InnerContainer>
        {questions.map((question) => (
          <QuestionAnswer
            question={question.question}
            answer={question.answer}
          />
        ))}
        <Line />
      </InnerContainer>
    </Container>
  );
};

export default Answers;
